<div
  bsModal
  #modal="bs-modal"
  class="modal fade"
  tabindex="-1"
  [config]="{
    backdrop: 'static',
    keyboard: false
  }"
>
  <div
    class="modal-dialog"
    style="min-width: 96vw"
  >
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title font-weight-bold">
          Etiqueta
        </div>
        <button
          type="button"
          class="close"
          (click)="onBtnFecharClick()"
        >
          <i class="fa fa-close"></i>
        </button>
      </div>
      <div class="modal-body">
        <app-etiqueta-mascarello
          #etiquetaElm
          [etiqueta]="etiqueta"
          [largura]="larguraDaEtiqueta"
          [altura]="alturaDaEtiqueta"
        >
        </app-etiqueta-mascarello>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-sm btn-primary"
          [disabled]="!etiquetaParaPdf"
          (click)="onBtnSalvarClick()"
        >
          <i class="fa fa-print"></i>
          <span> Imprimir </span>
        </button>
      </div>
    </div>
  </div>
</div>
